import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs'
import WhatsAppTemplateList from '../TemplateCenter/WhatsAppTemplateList';
import SMSTemplateList from '../TemplateCenter/SMSTemplateList'
import EmailTemplateList from '../TemplateCenter/EmailTemplateList';
import WhatsAppConfiguration from './WhatsAppConfiguration';
import ConfigurationCenterController from '../../../../Controllers/AdminScreens/Configuration/ConfigurationCenter/ConfigurationCenterController';
import EmailConfigurationScreen from './EmailConfigurationScreen';
import SmsConfigurationScreen from './SmsConfigurationScreen';


const ConfigurationCenterScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };

    const {
        whatsAppData,
        whatsAppError,
        whatsAppLoading,

        emailData,
        emailError,
        emailLoading,

        smsData,
        smsError,
        smsLoading,
        fetchWhatsAppConfig,
        fetchEmailConfig,
        fetchSmsConfig,
        whatsAppStatus,
        tabs,
    } = ConfigurationCenterController();

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 10 }}>
                <h2 className='title'>Configuration Center</h2>
            </div>

            <div >
                <Tabs tabs={tabs}
                    selectedIndex={selectedTab}
                    onTabChange={handleTabChange}>
                    {tabs.map((tab) => {
                        switch (tab) {
                            case 'WhatsApp':
                                return (
                                    <WhatsAppConfiguration
                                        key="whatsapp"
                                        data={whatsAppData}
                                        loading={whatsAppLoading}
                                        error={whatsAppError}
                                        onRefresh={fetchWhatsAppConfig}
                                    />
                                );
                            case 'Email':
                                return (
                                    <EmailConfigurationScreen
                                        key="email"
                                        data={emailData}
                                        loading={emailLoading}
                                        error={emailError}
                                        onRefresh={fetchEmailConfig}
                                    />
                                );
                            case 'SMS':
                                return (
                                    <SmsConfigurationScreen
                                        key="sms"
                                        data={smsData}
                                        loading={smsLoading}
                                        error={smsError}
                                        onRefresh={fetchSmsConfig}
                                    />
                                );
                            default:
                                return null;
                        }
                    })}
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default ConfigurationCenterScreen;